import {
  Box,
  makeStyles,
  MenuItem,
  TextField,
  Typography,
} from "@material-ui/core";
import React from "react";
import {
  QuoteIcon,
  MobileChatIcon,
  HeadsetIcon,
  CalendarIcon,
  InstallerIcon,
  CustomerSupportIcon,
  MaskIcon,
  InstallMaskIcon,
  GuaranteeIcon,
  MonthIcon,
  WarrantyIcon12,
  DeleteIcon,
} from "../../components/Icons";
import { colors } from "swyft-react-core";

const useStyles = makeStyles((theme) => ({
  root: {
    "&>*>svg": {
      margin: theme.spacing(3),
      height: "3rem",
      width: "3rem",
    },
  },
  secondary: {
    "& svg": {
      stroke: theme.palette.secondary.main,
      fill: theme.palette.secondary.main,
    },
  },
  primary: {
    "& svg": {
      stroke: theme.palette.primary.main,
      fill: theme.palette.primary.main,
    },
  },
}));

export const IconsPage: React.FC = () => {
  const classes = useStyles();

  const [colour, setColour] = React.useState(colors.primary);

  const handleChangeColour = (event: React.ChangeEvent<HTMLInputElement>) => {
    setColour(event.target.value);
  };

  const colours = [
    { value: colors.primary, label: "Primary" },
    { value: colors.secondary, label: "Secondary" },
    { value: "red", label: "Red" },
    { value: "green", label: "Green" },
    { value: "blue", label: "Blue" },
  ];

  return (
    <Box className={classes.root}>
      <Box p={2}>
        <Typography variant="h2">Primary</Typography>
        <InstallerIcon color="primary" />
        <MaskIcon color="primary" />
        <InstallMaskIcon color="primary" />
        <CustomerSupportIcon color="primary" />
        <HeadsetIcon color="primary" />
        <MobileChatIcon color="primary" />
        <CalendarIcon color="primary" />
        <MonthIcon color="primary" />
        <QuoteIcon color="primary" />
        <GuaranteeIcon color="primary" />
        <WarrantyIcon12 color="primary" />
        <DeleteIcon color="primary" />
      </Box>
      <Box p={2}>
        <Typography variant="h2">Secondary</Typography>
        <InstallerIcon color="secondary" />
        <MaskIcon color="secondary" />
        <InstallMaskIcon color="secondary" />
        <CustomerSupportIcon color="secondary" />
        <HeadsetIcon color="secondary" />
        <MobileChatIcon color="secondary" />
        <CalendarIcon color="secondary" />
        <MonthIcon color="secondary" />
        <QuoteIcon color="secondary" />
        <GuaranteeIcon color="secondary" />
        <WarrantyIcon12 color="secondary" />
        <DeleteIcon color="secondary" />
      </Box>
      <Box p={2}>
        <Typography variant="h2">Select</Typography>
        <Box maxWidth={300}>
          <TextField
            select
            fullWidth
            label="Select Colour"
            value={colour}
            onChange={handleChangeColour}
          >
            {colours.map((colour) => (
              <MenuItem key={colour.value} value={colour.value}>
                {colour.label}
              </MenuItem>
            ))}
          </TextField>
        </Box>
        <InstallerIcon iconColor={colour} />
        <MaskIcon iconColor={colour} />
        <InstallMaskIcon iconColor={colour} />
        <CustomerSupportIcon iconColor={colour} />
        <HeadsetIcon iconColor={colour} />
        <MobileChatIcon iconColor={colour} />
        <CalendarIcon iconColor={colour} />
        <MonthIcon iconColor={colour} />
        <QuoteIcon iconColor={colour} />
        <GuaranteeIcon iconColor={colour} />
        <WarrantyIcon12 iconColor={colour} />
        <DeleteIcon iconColor={colour} />
      </Box>

      <Box>
        <Typography variant="h1">H1 Lorem Ipsum</Typography>
        <Typography variant="h2">H2 Lorem Ipsum</Typography>
        <Typography variant="h3">H3 Lorem Ipsum</Typography>
        <Typography variant="h4">H4 Lorem Ipsum</Typography>
        <Typography variant="h5">H5 Lorem Ipsum</Typography>
        <Typography variant="h6">H6 Lorem Ipsum</Typography>
        <Typography variant="body1">Body1 Lorem Ipsum</Typography>
        <br />
        <Typography variant="body2">Body2 Lorem Ipsum</Typography>
        <br />
        <Typography variant="subtitle1">Subtitle1 Lorem Ipsum</Typography>
        <br />
        <Typography variant="subtitle2">Subtitle2 Lorem Ipsum</Typography>
        <br />
        <Typography variant="caption">caption Lorem Ipsum</Typography>
        <br />
        <Typography variant="button">button Lorem Ipsum</Typography>
        <br />
        <Typography variant="overline">overline Lorem Ipsum</Typography>
        <br />
        <Typography variant="srOnly">srOnly Lorem Ipsum</Typography>
        <br />
        <Typography variant="inherit">Inherit Lorem Ipsum</Typography>
        <br />
      </Box>
    </Box>
  );
};
